import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';
import * as Utils from '@shared/core/utils';

export const getWizzardSimpleItemTotalValue = createSelector(wizzardState, (wizzard) => {
    if (!wizzard.itemsSimple) {
        return null;
    }

    return Utils.Pricing.calculateTotalPriceForSimpleItem(wizzard.itemsSimple);
});
